import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf50b930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "col-sm-7" }
const _hoisted_6 = { class: "row justify-content-end" }
const _hoisted_7 = { class: "col-sm-2" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label text-right" }, "Ref", -1))
const _hoisted_10 = { class: "col-sm-9" }
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label text-right" }, "Type", -1))
const _hoisted_14 = { class: "col-sm-9" }
const _hoisted_15 = { class: "col-sm-3" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label text-right" }, "Date", -1))
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = {
  key: 0,
  class: "col-sm-3"
}
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label text-right" }, "Customer", -1))
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = {
  key: 0,
  class: "text-right"
}
const _hoisted_24 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Download Report PDFs"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "btn-group ml-3",
  role: "group",
  "aria-label": "Download Report PDFs"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_29 = { class: "report-items" }
const _hoisted_30 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_31 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_35 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_36 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_37 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_38 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_39 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_40 = {
  key: 7,
  class: "nav-item"
}
const _hoisted_41 = {
  key: 8,
  class: "nav-item"
}
const _hoisted_42 = {
  key: 9,
  class: "nav-item"
}
const _hoisted_43 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_44 = { class: "container-fluid" }
const _hoisted_45 = { id: "status-bar-buttons" }
const _hoisted_46 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Navigation"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" })
], -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Extra info"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light",
  "data-toggle": "modal",
  "data-target": "#report-notes-modal",
  title: "Notes"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-sticky-note" })
], -1))
const _hoisted_51 = {
  key: 0,
  class: "btn btn-light",
  "data-toggle": "modal",
  "data-target": "#report-qc-notes-modal",
  title: "QC Notes"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-sticky-note" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1))
const _hoisted_54 = {
  key: 1,
  class: "btn-group",
  role: "group",
  "aria-label": "Expand/collapse"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-expand" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-compress" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 2,
  class: "btn-group",
  role: "group",
  "aria-label": "Add Room/Item"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light",
  "data-toggle": "modal",
  "data-target": "#report-room-modal",
  title: "Add Room"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }),
  /*#__PURE__*/_createTextVNode(" Room ")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light",
  "data-toggle": "modal",
  "data-target": "#report-item-modal",
  title: "Add Item"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }),
  /*#__PURE__*/_createTextVNode(" Item ")
], -1))
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = {
  key: 3,
  class: "btn-group",
  role: "group"
}
const _hoisted_64 = {
  key: 0,
  id: "status-bar-switches"
}
const _hoisted_65 = { class: "custom-control custom-switch" }
const _hoisted_66 = ["checked"]
const _hoisted_67 = {
  class: "custom-control-label text-light",
  for: "locked"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-unlock" }, null, -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "custom-control custom-switch" }
const _hoisted_75 = {
  class: "custom-control-label text-light",
  for: "appendImages"
}
const _hoisted_76 = { key: 0 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-down" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera" }, null, -1))
const _hoisted_79 = { key: 1 }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrows-alt-v" }, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera" }, null, -1))
const _hoisted_82 = {
  key: 0,
  class: "custom-control custom-switch"
}
const _hoisted_83 = ["checked"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label text-light",
  for: "flagged"
}, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" })
  ])
], -1))
const _hoisted_85 = {
  key: 1,
  class: "custom-control custom-switch"
}
const _hoisted_86 = ["checked"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label text-light",
  for: "flaggedCOSM"
}, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-stripe-s mr-1" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-flag" })
  ])
], -1))
const _hoisted_88 = { id: "status-bar-actions" }
const _hoisted_89 = { class: "text-light" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_92 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Secondary Actions"
}
const _hoisted_93 = ["disabled"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_95 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Primary Actions"
}
const _hoisted_96 = ["disabled"]
const _hoisted_97 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = {
  key: 1,
  class: "fas fa-save"
}

import { computed, onMounted, ref, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from "vue-toastification";
import { emitEvent } from '@/eventBus';
import _ from "lodash";

import LinkedReportsModal from '@/components/modals/LinkedReportsModal.vue';
import ReportConflictModal from '@/components/modals/ReportConflictModal.vue';
import ReportNotesModal from '@/components/modals/ReportNotesModal.vue';
import ReportMergeModal from '@/components/modals/ReportMergeModal.vue';
import ReportQCNotesModal from '@/components/modals/ReportQCNotesModal.vue';
import ProgressButton from '@/components/ProgressButton.vue';

import { Report, Dictionary, CustomerDictionary } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const actProperty: any = inject('actProperty');
const toasted = useToast();

const conflictModal = ref(null);

const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const customerdictionary = computed((): CustomerDictionary => store.getters['customerdictionary/current']);
const statereport = computed(() => store.getters['reports/current']);
const hasUnsavedChanges = computed(() => store.getters['reports/hasUnsavedChanges']);
const isDataentry = computed(() => store.getters['auth/isDataentry']);
const isCustomer = computed(() => store.getters['auth/isCustomer']);
const isAdministrator = computed(() => store.getters['auth/isAdministrator']);
const cognitoUser = computed(() => store.getters['auth/cognitoUser']);

const removeRequest = (id: string) => {
  store.commit('app/removeRequest', id);
};

const resetUnsavedChanges = () => {
  store.commit('reports/resetUnsavedChanges');
};

const unsetCurrentReport = () => {
  store.commit('reports/unsetCurrentReport');
};

const setCurrentReportLocked = (locked: boolean) => {
  store.commit('reports/setCurrentReportLocked', locked);
};

const setCurrentReportFlagged = (flagged: boolean) => {
  store.commit('reports/setCurrentReportFlagged', flagged);
};

const setCurrentCOSMReportFlagged = (flaggedCOSM: boolean) => {
  store.commit('reports/setCurrentCOSMReportFlagged', flaggedCOSM);
};

const getReport = (id: string) => store.dispatch('reports/getReport', id);
const getLinkedReports = (id: string) => store.dispatch('reports/getLinkedReports', id);
const setReportDeep = (payload: { path: string; data: any }) => store.dispatch('reports/setReportDeep', payload);
const toggleReportLock = (report: Report) => store.dispatch('reports/toggleReportLock', report);
const toggleReportFlag = (report: Report) => store.dispatch('reports/toggleReportFlag', report);
const toggleCOSMReportFlag = (report: Report) => store.dispatch('reports/toggleCOSMReportFlag', report);
const toggleReportAppendImages = (report: Report) => store.dispatch('reports/toggleReportAppendImages', report);
const setCurrentReportSameAsCheckin = () => store.dispatch('reports/setCurrentReportSameAsCheckin');
const addReport = () => store.dispatch('reports/addReport');
const updateReport = () => store.dispatch('reports/updateReport');
const deleteReport = () => store.dispatch('reports/deleteReport');
const downloadInvoiceAction = (report: Report) => store.dispatch('reports/downloadInvoice', report);
const downloadReportAction = (report: Report) => store.dispatch('reports/downloadReport', report);
const generateReportPdfAction = (report: Report) => store.dispatch('reports/generateReportPdf', report);
const generateReportSummaryPdfAction = (report: Report) => store.dispatch('reports/generateReportSummaryPdf', report);
const getCustomersDictionaryAction = (payload?: { companyname?: string; branchname?: string; reporttype?: string }) => store.dispatch('customerdictionary/getCustomerDictionary', payload);
const getReportactiveCompanyNameOptions = (reportname: string) => store.dispatch('customers/getReportactiveCompanyNameOptions', reportname);

// Converted data properties
const companyNameOptions = ref<string[]>([]);
const isSaving = ref(false);

const reportDate = computed({
  get: () => actProperty.dateToLocalTime(statereport.value.date),
  set: (data: string) => {
    if (data) {
      if (isNewReport()) {
        setReportDeep({
          path: "date",
          data: actProperty.datetimeToUTC(data),
        });
      } else if (confirm("Do you really want to change the Report date?")) {
        setReportDeep({
          path: "date",
          data: actProperty.datetimeToUTC(data),
        });
      } else {
        setReportDeep({ path: "date", data: statereport.value.date });
      }
    }
  }
});

const reportTitle = computed({
  get: () => statereport.value.title === undefined ? defaultReportTitle() : statereport.value.title,
  set: (data: string) => setReportDeep({ path: "title", data })
});

const reportType = computed({
  get: () => statereport.value.type,
  set: (data: string) => setReportDeep({ path: "type", data })
});

const addressLine1 = computed({
  get: () => statereport.value.address.line1,
  set: (data: string) => setReportDeep({ path: "address.line1", data })
});

const addressPostcode = computed({
  get: () => statereport.value.address.postcode,
  set: (data: string) => setReportDeep({ path: "address.postcode", data })
});

const reportCompanyName = computed({
  get: () => statereport.value.companyName,
  set: (data: boolean) => setReportDeep({ path: "companyName", data })
});

const onSelectCompanyName = (companyName: string) => {
  if (companyName) {
    reportCompanyName.value = companyName;
  }
}

const reportTypes = computed({
  get: () => {
    if (isDataentry.value) return ["inventory"];
    else return ["inventory", "soc", "checkin", "checkout", "property visit"];
  },
  set: (data: string[]) => { }
});

const onTagCompanyName = (val: string) => {
  reportCompanyName.value = val;
}

const isNewReport = () => {
  return route.params.id == "new";
}

const defaultReportTitle = (): string => {
  return actProperty.formatReportType(
    statereport.value.type,
    dictionary.value
  );
}

const saveAll = () => {  
  if(isDataentry.value && !statereport.value.propertyDetails.tenancystartdate){
    toasted.error(`Tenancy start date required`);
    return;
  }
  if (isNewReport()) {
    addReport()
      .then((report: Report) => {
        toasted.success(`Saved`);
        if (isDataentry.value) router.push(`/dereports/${report.id}`);
        else router.push(`/reports/${report.id}`);
      })
      .catch((err: any) => actProperty.displayError(err));
  } else {
    // No need to save an empty, or default, Report.title
    if (
      !statereport.value.title ||
      statereport.value.title === defaultReportTitle()
    ) {
      setReportDeep({ path: "title", data: undefined });
    }

    // check if invoice detail is valid
    // Depending on customer setting, workorder number of landlord email
    // are required field
    let error = false;
    if (statereport.value.customer) {
      if (
        statereport.value.customer.workordernumberrequired &&
        !statereport.value.workorderNumber
      ) {
        isSaving.value = false;
        error = true;
        actProperty.displayError(
          "Works/Purchase order number is required"
        );
      }
      if (
        statereport.value.customer.accountsettings.llemailrequired &&
        !statereport.value.client.email
      ) {
        isSaving.value = false;
        error = true;
        actProperty.displayError("Client e-mail is required");
      }
    }
    if (!error) {
      toasted.warning(`Saving`);
      isSaving.value = true;
      updateReport()
        .then((report: Report) => {
          isSaving.value = false;
          toasted.success(`Saved`);
        })
        .catch((err: any) => {
          // Check for 409 Conflict
          if (_.get(err, "response.data.statusCode") === 409) {
            const modal = conflictModal.value as any;
            modal.show();
          } else {
            actProperty.displayError(err);
          }
          isSaving.value = false;
        });
    }
  }
}

const init = async () => {
  if (!route.params.id) return;
  try {
    const report = await getReport(route.params.id as string);
    emitEvent("reportLoadedOnEditReportPage",report);
    if (report === undefined) {
      actProperty.displayError("Could not load Report");
      router.push({ name: "reports" });
    }

    if (route.params.id === "new" && isDataentry.value) {
      setReportDeep({
        path: "user",
        data: cognitoUser.value.username,
      });
      reportType.value = "inventory";
      resetUnsavedChanges();
    }

    if (!isAdministrator.value) {
      const routeName = isDataentry.value ? `dereport-details` : `report-details`;
      router.push({
        name: routeName,
        query: { t: new Date().getTime().toString() },
      });
    }

    if (reportType.value === "inventory" && !reportTitle.value) {
      reportTitle.value = "Inventory Make & Check In";
    }

    if (report && report.companyName) {
      let cname = report.companyName;
      if (report.branchName && report.branchName !== "default") {
        cname = report.branchName;
      }
      getCustomerDictionary(cname, "default", report.type);
    }

    if (isAdministrator.value && actProperty.isFactoryreport(report.type)) {
      try {
        const values = await getReportactiveCompanyNameOptions(report.type);
        companyNameOptions.value = values;
      } catch (err) {
        actProperty.displayError(err);
      }
    }
  } catch (err) {
    actProperty.displayError(err);
    const replaceRoute = isDataentry.value ? "/dereports" : "/reports";
    router.replace(replaceRoute);
  }
};

const getCustomerDictionary = (
  companyname: any,
  branchname: any,
  reporttype: any
) => {
  if (companyname && companyname === "ACT") companyname = "default";
  getCustomersDictionaryAction({
    companyname,
    branchname,
    reporttype,
  }).catch((err: any) => {
    actProperty.displayError(err);
  });
};

const cosummaryactive = computed(() => {
  let result = true;
  if (
    statereport.value &&
    statereport.value.customer &&
    statereport.value.customer.reportsettings
  ) {
    result =
      statereport.value &&
      statereport.value.customer &&
      statereport.value.customer.reportsettings.cosummaryactive;
  }
  return result;
});

const showSection = (section: string) => {
  let flag: boolean = false;
  if (actProperty.isFactoryreport(statereport.value.type)) {
    switch (section) {
      case "Visit Checks":
        flag = true;
        break;
      case "Keys":
        flag = customerdictionary.value.report_configuration.showkeys;
        break;
      case "Keys Return":
        flag = customerdictionary.value.report_configuration.showkeysreturn;
        break;
      case "Meters":
        flag = customerdictionary.value.report_configuration.showmeters;
        break;
      case "Alarms":
        flag = customerdictionary.value.report_configuration.showalarms;
        break;
      case "Manuals":
        flag =
          customerdictionary.value.report_configuration
            .showappliancesandmanuals;
        break;
      case "Comments":
        flag = false;
        break;
    }
  } else {
    switch (statereport.value.type) {
      case "inventory":
        flag = true;
        break;
      case "soc":
        flag = true;
        break;
      case "checkin":
        flag = true;
        break;
      case "checkout":
        flag = true;
        break;
      default:
        throw Error("Unexpected report type");
    }

    if (section == "Visit Checks") {
      flag = false;
    } else if (section === "Depository") {
      flag = false;
      // Only show depository for checkout and if the associated customer is active on depositary
      if (
        statereport.value.type === "checkout" &&
        statereport.value?.customer?.depository?.authToken
      ) {
        flag = true;
      }
    }
  }
  return flag;
}

const scrollToTop = () => {
  window.scrollTo(0, 0);
}

const cancel = () => {
  resetUnsavedChanges();
  router.go(0);
}

/**
 * Toggle lock
 */
const toggleLock = () => {
  toggleReportLock(statereport.value)
    .then((report: Report) => {
      setCurrentReportLocked(report.locked);
      toasted.success(
        `${report.ref} ${report.locked ? "Locked" : "Unlocked"}`
      );
    })
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Toggle Flag
 */
const toggleFlag = () => {
  toggleReportFlag(statereport.value)
    .then((report: Report) => {
      setCurrentReportFlagged(report.flagged);
      toasted.success(
        `${report.ref} ${report.flagged ? "Flagged CO Report" : "Unflagged CO Report"
        }`
      );
    })
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Toggle COSM Flag
 */
const toggleCOSMFlag = () => {
  toggleCOSMReportFlag(statereport.value)
    .then((report: Report) => {
      setCurrentCOSMReportFlagged(report.flaggedCOSM);
      toasted.success(
        `${report.ref} ${report.flaggedCOSM ? "Flagged COSM Report" : "Unflagged COSM Report"
        }`
      );
    })
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Toggle Appended Images
 */
const toggleAppendImages = () => {
  toggleReportAppendImages(statereport.value)
    .then((report: Report) =>
      toasted.success(
        report.appendImages ? "Images appended" : "Images by section"
      )
    )
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Download Invoice PDF
 */
const downloadInvoice = (report: Report, requestId: string): void => {
  downloadInvoiceAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Invoice ${report.ref} PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Generate INV/CI/CO Report PDF
 */
const generateReportPdf = (report: Report, requestId: string): void => {
  generateReportPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Generate COSM Report PDF
 */
const generateReportSummaryPdf = (report: Report, requestId: string): void => {
  generateReportSummaryPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} Summary PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

/**
 * Expand All Rooms
 */
const expandAll = () => {
  emitEvent("expandAll", );
}

/**
 * Collapse All Rooms
 */
const collapseAll = () => {
  emitEvent("collapseAll");
}

/**
 * Apply SACI to all CO Condition Notes
 */
const sameAsCheckin = () => {
  actProperty
    .confirmPrompt(
      'Apply "Same as Check-In" to all items without Check-Out conditions?'
    )
    .then(() => setCurrentReportSameAsCheckin())
    .then((amends: string) =>
      toasted.success(`"Same as Check-In" applied to ${amends} items`)
    )
    .catch((err: any) => actProperty.displayError(err));
}

const addressPreviewLine1 = () => {
  return `${addressLine1.value}${addressLine1.value ? "," : ""}`;
}

const addressPreviewLine2 = () => {
  return `${addressPostcode.value}`;
}

const formatReportType = (type: string) => {
  return actProperty.formatReportType(type, dictionary.value);
}

onMounted(() => {
  init();
})

watch(() => route.params.id, (newValue) => {
  if (route.params.id) {
    init();
  }
});


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, [
          _createTextVNode(_toDisplayString(addressPreviewLine1()), 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(addressPreviewLine2()), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  disabled: "",
                  readonly: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statereport.value.ref) = $event))
                }, null, 512), [
                  [_vModelText, statereport.value.ref]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (isNewReport())
                  ? (_openBlock(), _createBlock(_component_multiselect_text, {
                      key: 0,
                      modelValue: reportType.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reportType).value = $event)),
                      options: reportTypes.value,
                      "custom-label": formatReportType
                    }, null, 8, ["modelValue", "options"]))
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((reportTitle).value = $event))
                    }, null, 512)), [
                      [_vModelText, reportTitle.value]
                    ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control",
                  min: "1990-01-01",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((reportDate).value = $event))
                }, null, 512), [
                  [_vModelText, reportDate.value]
                ])
              ])
            ])
          ]),
          (isAdministrator.value && _unref(actProperty).isFactoryreport(statereport.value.type)
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_multiselect_text, {
                      modelValue: reportCompanyName.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((reportCompanyName).value = $event)),
                      value: reportCompanyName.value,
                      options: companyNameOptions.value,
                      "allow-empty": true,
                      taggable: true,
                      onTag: onTagCompanyName,
                      onSelect: onSelectCompanyName
                    }, _createSlots({ _: 2 }, [
                      (reportCompanyName.value.length)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onTagCompanyName('')), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Company Name"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "value", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!isNewReport())
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(ProgressButton, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(actProperty).copyDownloadButton(statereport.value, 'report'))),
                  onDblclick: _cache[7] || (_cache[7] = ($event: any) => (generateReportPdf(statereport.value, $event))),
                  class: "btn btn-outline-primary",
                  title: formatReportType(statereport.value.type),
                  disabled: isSaving.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(formatReportType(statereport.value.type)), 1)
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                (statereport.value.type == 'checkout')
                  ? (_openBlock(), _createBlock(ProgressButton, {
                      key: 0,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(actProperty).copyDownloadButton(statereport.value, 'summary'))),
                      onDblclick: _cache[9] || (_cache[9] = ($event: any) => (generateReportSummaryPdf(statereport.value, $event))),
                      class: "btn btn-outline-primary",
                      title: "Check-Out Summary",
                      disabled: isSaving.value || !cosummaryactive.value
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26,
                        _createTextVNode(" Summary ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              (!isDataentry.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(ProgressButton, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(actProperty).copyDownloadButton(statereport.value, 'invoice'))),
                      onDblclick: _cache[11] || (_cache[11] = ($event: any) => (downloadInvoice(statereport.value, $event))),
                      disabled: !statereport.value.totalFees() || isSaving.value,
                      class: "btn btn-outline-primary",
                      title: "Invoice"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _createTextVNode(" Invoice ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("ul", _hoisted_30, [
        (isAdministrator.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
              _createVNode(_component_router_link, {
                to: "invoice",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Invoice ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_32, [
          _createVNode(_component_router_link, {
            to: "details",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Details ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_33, [
          _createVNode(_component_router_link, {
            to: "rooms",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Rooms ")
            ]),
            _: 1
          })
        ]),
        (showSection('Keys'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
              _createVNode(_component_router_link, {
                to: "keys",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Keys ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Keys Return'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                to: "keysreturn",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Key Return ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Meters'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                to: "meters",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Meters ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Alarms'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
              _createVNode(_component_router_link, {
                to: "alarms",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Alarms ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Manuals'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
              _createVNode(_component_router_link, {
                to: "manuals",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Manuals ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Comments'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
              _createVNode(_component_router_link, {
                to: "comments",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Comments ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Signatures'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
              _createVNode(_component_router_link, {
                to: "signatures",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Signatures ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showSection('Visit Checks'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
              _createVNode(_component_router_link, {
                to: "visitchecks",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Visit Checks ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (statereport.value.customer.depository.authToken)
          ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
              _createVNode(_component_router_link, {
                to: "depositary",
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Depositary ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              class: "btn btn-outline-light",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (scrollToTop())),
              title: "Back to top"
            }, _hoisted_48)
          ]),
          (!isDataentry.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                (!isCustomer.value)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_51, [
                      _hoisted_52,
                      _createTextVNode(" QC ")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-light",
                  "data-toggle": "modal",
                  "data-target": "#linked-reports-modal",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (getLinkedReports(statereport.value.id))),
                  title: "Linked Reports"
                }, [
                  _hoisted_53,
                  _createElementVNode("span", null, " (" + _toDisplayString(statereport.value.linkedReports.length) + ")", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(route).name === 'report-rooms' ||
            _unref(route).name === 'dereport-rooms'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (expandAll())),
                  title: "Expand All"
                }, _hoisted_56),
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (collapseAll())),
                  title: "Collapse All"
                }, _hoisted_58)
              ]))
            : _createCommentVNode("", true),
          (_unref(route).name === 'report-rooms' ||
            _unref(route).name === 'dereport-rooms'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_62))
            : _createCommentVNode("", true),
          ((_unref(route).name === 'report-rooms' ||
              _unref(route).name === 'dereport-rooms') &&
            statereport.value.type === 'checkout'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (sameAsCheckin())),
                  title: "Toggle Same as Check-In"
                }, " SACI ")
              ]))
            : _createCommentVNode("", true)
        ]),
        (false === isNewReport() && !isDataentry.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "locked",
                  checked: statereport.value.locked,
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (toggleLock()))
                }, null, 40, _hoisted_66),
                _createElementVNode("label", _hoisted_67, [
                  (statereport.value.locked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, _hoisted_70))
                    : (_openBlock(), _createElementBlock("span", _hoisted_71, _hoisted_73))
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "appendImages",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((statereport.value.appendImages) = $event)),
                  onChange: _cache[19] || (_cache[19] = ($event: any) => (toggleAppendImages()))
                }, null, 544), [
                  [_vModelCheckbox, statereport.value.appendImages]
                ]),
                _createElementVNode("label", _hoisted_75, [
                  (statereport.value.appendImages)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                        _hoisted_77,
                        _createTextVNode(" "),
                        _hoisted_78
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_79, [
                        _hoisted_80,
                        _createTextVNode(" "),
                        _hoisted_81
                      ]))
                ])
              ]),
              (statereport.value.type === 'checkout')
                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "flagged",
                      checked: statereport.value.flagged,
                      onChange: _cache[20] || (_cache[20] = ($event: any) => (toggleFlag()))
                    }, null, 40, _hoisted_83),
                    _hoisted_84
                  ]))
                : _createCommentVNode("", true),
              (statereport.value.type === 'checkout')
                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "flaggedCOSM",
                      checked: statereport.value.flaggedCOSM,
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (toggleCOSMFlag()))
                    }, null, 40, _hoisted_86),
                    _hoisted_87
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_90, "You have unsaved changes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_91, "No unsaved changes")),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-outline-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (cancel()), ["prevent"])),
                disabled: !hasUnsavedChanges.value
              }, [
                _hoisted_94,
                _createTextVNode(" Cancel ")
              ], 10, _hoisted_93)
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (saveAll()), ["prevent"])),
                disabled: isSaving.value || !hasUnsavedChanges.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_97, _hoisted_99))
                  : (_openBlock(), _createElementBlock("i", _hoisted_100)),
                _createTextVNode(" Save ")
              ], 10, _hoisted_96)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(LinkedReportsModal),
    _createVNode(ReportConflictModal, {
      ref_key: "conflictModal",
      ref: conflictModal
    }, null, 512),
    _createVNode(ReportNotesModal),
    _createVNode(ReportMergeModal),
    _createVNode(ReportQCNotesModal)
  ]))
}
}

})